import React from 'react';
import { marker } from 'leaflet';

import { Marker } from 'react-leaflet';

import BVMarker from '../img/BVMarker.png';

export const MapMarker = ({lat, lng, id, name, onHoverIn, onHoverOut, onClick}) => {
  return (
    <div
      className={'marker search-result'}
      id={id}
      position={[lat, lng]}
      onClick={() => onClick(id)}
      onMouseEnter={(e) => onHoverIn(id)}
      onMouseLeave={(e) => onHoverOut()} >
        <Marker
          icon={BVMarker}
          position={[lat, lng]}
          name={name} />
    </div>
  );
};